<script>
import Vue from "vue";
import store from "@/state/store";
import VTooltip from "v-tooltip";
import Swal from "sweetalert2";

Vue.use(VTooltip);
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrPerfRaporGiris from "@/models/StrPerfRaporGiris";

import "v-tooltip/dist/v-tooltip.css";

export default {
  mixins: [Api, Sabit, StrPerfRaporGiris],
  props: ["TabloId", "BirimId", "DonemId", "Sorgulama", "Onayid", "Universite"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      TabloVerileri: [],
      TabloDetayVerileri: [],
      Basliklar: [],
      Veriler: [],
      FormData: [],
      AltDonemler: [],
      gostergelistesi: [],
      ilk_deger: [],
      DonemOnay: [],
      deger: "",
      aciklama: "",
      sayac: 0,
      kontrol: 0,
      bugun: null,
      NoOlcumPeriyodu: true,
      VeriGirisDurum: [],
      Message: {
        position: "",
        icon: "",
        title: "",
        showConfirmButton: false,
        timer: 1500,
      },
    };
  },

  watch: {
    Sorgulama() {
      this.Get();
    },
  },

  methods: {
    kaydet(veri) {
      console.log(veri);
      if (veri.Deger != this.ilk_deger) {
        if (veri.Deger != null) {
          this.$delete(veri, "DonemAdi");
          this.$delete(veri, "BaslamaTarihi");
          this.$delete(veri, "BitisTarihi");
          this.$delete(veri, "HedefMi");
          this.$delete(veri, "Onay");

          if (
            veri.Id == "00000000-0000-0000-0000-000000000000" ||
            veri.id == ""
          ) {
            this.$delete(veri, "Id");

            this.Post("StrPerfRaporGiris", veri);
          } else {
            this.Update("StrPerfRaporGiris", veri);
          }
        } else {
          this.$toast.error(this.$t("Lütfen geçerli bir değer giriniz!"));
        }
      }
    },

    formul_goster(formul) {
      let hesaplanacak = formul;
      let karakter1;
      let karakter2;

      for (var i = 0; i < hesaplanacak.length; i++) {
        if (hesaplanacak[i] == "{") {
          karakter1 = i + 1;
        }
        if (hesaplanacak[i] == "}") {
          karakter2 = i;
          for (var k = 0; k < this.gostergelistesi.length; k++) {
            if (
              this.gostergelistesi[k].Id ==
              hesaplanacak.substring(karakter1, karakter2)
            ) {
              formul = formul.replaceAll(
                "{" + this.gostergelistesi[k].Id + "}",
                this.gostergelistesi[k].Gostergesi
              );
            }
          }
        }
      }

      return formul;
    },

    hesapla(formul, veri, formulduzey) {

      if (formulduzey != null && formulduzey != "") {

        let data = { "Donemid": veri.DonemId, "Formul": formul, "Ustdonemid": this.DonemId, "Birimid": this.BirimId, "Formulduzey": formulduzey };


        this.Post("StrPerfRaporGiris/GetFormulSonuc", data, false).then((res) => {

          if (res.Succeeded) {

            veri.Deger = parseFloat(res.Data.replace(",", "."));

            this.kaydet(veri);

          } else {

            this.Message.html = "";
            this.Message.position = "center";
            this.Message.icon = "warning";
            this.Message.title = res.Errors[0];
            this.Message.showConfirmButton = false;
            this.Message.timer = 100000;

            let hata_mesaji = "Hata!";
            if (res.Errors.length > 0) {
              hata_mesaji = "";
              for (var i = 1; i < res.Errors.length; i++) {
                hata_mesaji = hata_mesaji + "<br>" + res.Errors[i];
              }

            }

            this.Message.html = hata_mesaji;

            Vue.swal(this.Message);

          }
        });

      } else {

        this.Message.html = "";
        this.Message.position = "center";
        this.Message.icon = "warning";
        this.Message.title = "Formül hesaplama düzeyi girilmemiş!";
        this.Message.showConfirmButton = false;
        this.Message.timer = 10000;

        Vue.swal(this.Message);

      }


    },

    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.AddEdit == "Add") {
          this.$delete(this.FormData, "Id");
          this.Post("StrPerfRaporGiris", this.FormData);
        } else {
          this.Update("StrPerfRaporGiris", this.FormData).then((res) => {
            if (res) {
              this.$emit("Update", this.FormData);
            }
          });
        }
      }
    },

    veri_gonder(
      DetayId,
      DonemId,
      BirimId,
      Raporgirisid,
      TabloDetayAciklama,
      Hesaplanmasin,
      AltDonemlerDetay
    ) {
      this.$emit("DetayId", DetayId);
      this.$emit("DonemId", DonemId);
      this.$emit("BirimId", BirimId);
      this.$emit("Raporgirisid", Raporgirisid);
      this.$emit("TabloDetayAciklama", TabloDetayAciklama);
      this.$emit("Hesaplanmasin", Hesaplanmasin);
      this.$emit("AltDonemlerDetay", AltDonemlerDetay);
    },
    kanit_veri_gonder(detay, onaydurumu) {
      this.$emit("Raporgirisid", detay);
      this.$emit("OnayDurumu", onaydurumu);
      this.$emit("Kontrolgirisid", null);
    },

    Get() {
      this.bugun = new Date();
      //alert(this.bugun);
      this.TabloVerileri = [];
      this.TabloDetayVerileri = [];
      this.Basliklar = [];

      this.ActionsGet({
        Service: "StrPerfTablolarDetay",
        Page: this.Page,
      }).then((res) => {
        this.gostergelistesi = res.Data;
      });

      let Filter = "&TabloId=" + this.TabloId + "&BirimId=" + this.BirimId + "&DonemId=" + this.DonemId;

      this.ActionsFilterGet({
        Service: "StrPerfRaporGiris/GetGostergeGiris",
        Page: this.Page,
        Filter: Filter,
      }).then((res) => {
        this.TabloVerileri = res.Data;
        this.TabloDetayVerileri = this.TabloVerileri[0].TabloDetay;
        this.Page.PageDataSize = res.TotalCount;


        for (var i = 0; i < this.TabloDetayVerileri[0].Giris.length; i++) {
          this.Basliklar.push(this.TabloDetayVerileri[0].Giris[i].DonemAdi);
        }
        this.$emit("yuklendi", 1);

      });
    },
    DonemOnayi(Donemid, Onay){
      if(Onay == 0 || Onay == null || Onay == ''){

      for(var Data in this.DonemOnay){
        if(this.DonemOnay[Data].Donemid == Donemid){
          if(this.DonemOnay[Data].Hedef == "Onaylı"){
            return true

          }else{
            return false
          }
        }
      }

      }else{
        return true
      }
    },
    DonemOnayla(DonemId, BirimId, UstId, VeriTipi) {
      Swal.fire({
        title: "Veri Kontrolü",
        text:
          "Burada Yer alan verilerin güvenilir, Tam ve Doğru olduğunu beyan ederim",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Onayla",
        cancelButtonText: "Vazgeç",
      }).then((result) => {
        if (result.value) {


          let onaylanacak = { "Ustdonemid": UstId, "Donemid": DonemId, "Birimid": BirimId, "Onay": "1", "Veritipi": VeriTipi };
          //console.log(onaylanacak)

          this.AllUpdate("StrPerfRaporGiris/UpdateDonemOnay", onaylanacak).then((res) => {


            if (res == true) {

              /*
              this.Message.position = "center";
                this.Message.icon = "warning";
                this.Message.title = res.Message;
                this.Message.showConfirmButton = false;
                this.Message.timer = 1000;

                Vue.swal(this.Message);
                */


              this.sayac++;
              this.$emit("Guncelle", this.sayac);

            } else {
              this.Message.html = "";
              this.Message.position = "center";
              this.Message.icon = "warning";
              this.Message.title = res.Message;
              this.Message.showConfirmButton = false;
              this.Message.timer = 100000;

              Vue.swal(this.Message);

            }

          });



        }
      });




    },

    DonemIptal(DonemId, BirimId) {
      Swal.fire({
        title: "Dikkat",
        text: "Dönem Onayı İptal Edilecek, Emin misiniz?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Onay İptal",
        cancelButtonText: "Vazgeç",
      }).then((result) => {

        if (result.value) {

          let onaylanacak = { BirimId: BirimId, DonemId: DonemId, Onay: 0 };
          this.AllUpdate("StrPerfRaporGiris/UpdateDonemOnay", onaylanacak).then(
            () => {

              this.sayac++;
              this.$emit("Guncelle", this.sayac);

            }
          );

        }

      });


      this.sayac++;
      this.$emit("Guncelle", this.sayac);

    },

    yetki_kontrol(yetki) {

      var sonuc = this.KullaniciBilgileri.indexOf(yetki);

      return sonuc;

    },

    sorgu_calistir(Sorguid, DonemId, BirimId, veri) {


      this.ActionsGet({ Service: "StrPerfDonem/" + DonemId, Page: this.Page }).then((res) => {
        if (res) {
          let yil = res.Data.BaslamaTarihi.substring(0, 4);

          let Filter = "&Sorguid=" + Sorguid + "&Birimid=" + BirimId + "&Yil=" + yil;

          this.ActionsFilterGet({
            Service: "StrPerfRaporGiris/GetSorguSonuc",
            Page: this.Page,
            Filter: Filter,
          }).then((sonuc) => {

            if (sonuc) {


              let deger = sonuc.Data.toString();

              veri.Deger = deger.replace(",", ".");

              this.kaydet(veri);

            }

          });

        }

      });


    },


  },
  computed: {},

  created() {
    this.KullaniciBilgileri = store.getters.["auth/UserRolles"];
    this.Get();
    let Page= {
        PageNumber: "1",
        PageSize: "9999"
      }
    let Filter = "&UstId=" + this.DonemId + "&Approval=true";
          this.ActionsFilterGet({ Service: "StrPerfDonem", Page: Page, Filter: Filter }).then((res) => {
            this.DonemOnay = []
            for (var i = 0; i < res.Data.length; i++) {
    
              let Filter2 = "&StrUstDonemId=" + this.DonemId +  "&StrDonemId=" + res.Data[i].Id + "&BirimId=" + this.BirimId + "&HedefOnayDurumKontrolMu=true";
              this.ActionsFilterGet({Service:"StrRaporlama/GetVeriGirisDurum",Page:Page, Filter:Filter2}).then(resp => {  
                this.DonemOnay.push(resp.Data[0]);
              }); 
            }
          });

   


  },
};
</script>
<template>
  <div>


    <div class="table-responsive mb-3" style="border: 2px solid #323748;">
      <table class="table table-striped mb-0">
        <tbody>
          <tr>
            <th width="200" scope="col">
              {{ $t("StrPerfRaporGiris.Table.Amac") }}
            </th>
            <td>{{ TabloVerileri[0].Amac }}</td>
          </tr>
          <tr>
            <th scope="col">{{ $t("StrPerfRaporGiris.Table.TabloAdi") }}</th>
            <td>{{ TabloVerileri[0].TabloAdi }} - {{ TabloVerileri[0].Hedefi }}</td>
          </tr>
          <tr>
            <th scope="col">
              {{ $t("StrPerfRaporGiris.Table.PerformansHedefi") }}
            </th>
            <td>{{ TabloVerileri[0].PerformansHedefi }}</td>
          </tr>
          <tr>
            <th scope="col">{{ $t("StrPerfRaporGiris.Table.Notu") }}</th>
            <td>{{ TabloVerileri[0].Notu }}</td>
          </tr>
          <tr>
            <td colspan="2">
              <div class="table-responsive">
                <table class="table table-striped mb-0">
                  <thead class="table-light">
                    <tr>
                      <th width="300" style="vertical-align: top;  " scope="col">
                        {{ $t("StrPerfRaporGiris.Table.Gosterge") }}
                      </th>
                      <th scope="col" style="vertical-align: top; text-align: center; ">
                        {{ $t("StrPerfRaporGiris.Table.HedefeEtkisi") }}
                      </th>

                      <template v-for="(AltDonemler, index) in TabloDetayVerileri[0].Giris">

                        <th scope="col" :key="index"
                          style="vertical-align: top; text-align: center; " v-if="AltDonemler.VeriTipi != 1 || Universite == 1 || AltDonemler.PerfGirisKurumBazinda == true">

                        <div v-if="AltDonemler.VeriTipi == 3 || (AltDonemler.VeriTipi == 2 && AltDonemler.PerfGirisKurumBazinda == false)  || Universite == 1">
                          <div v-if="Onayid == 0" style="margin-bottom: 5px;">
                            <div v-if="yetki_kontrol('StrPerformansGirisOnay') >= 0 || yetki_kontrol('StrAdmin') >= 0
                              || yetki_kontrol('SuperAdmin') >= 0">
  <div v-if="((AltDonemler.VeriTipi == 2 && !DonemOnayi(AltDonemler.DonemId, AltDonemler.Onay)) || (AltDonemler.VeriTipi != 2 && (AltDonemler.Onay == 0 || AltDonemler.Onay == null || AltDonemler.Onay == '')))"> 


                                <button class="btn btn-success btn-label" type="button" @click="
                                  DonemOnayla(
                                    AltDonemler.DonemId,
                                    AltDonemler.BirimId,
                                    DonemId,
                                    AltDonemler.VeriTipi
                                  )
                                  " v-tooltip="$t('StrPerfRaporGiris.Table.BtnOnay')">
                                  <i class="bx bx-check-double label-icon"></i> </button>



                              </div>
                              <div v-else>

                                <div v-if="yetki_kontrol('StrAdmin') >= 0 || yetki_kontrol('SuperAdmin') >= 0">

                                  <button class="btn btn-danger btn-label" type="button" @click="
                                    DonemIptal(
                                      AltDonemler.DonemId,
                                      AltDonemler.BirimId,
                                      TabloVerileri[0].TabloId
                                    )
                                    " v-tooltip="$t('StrPerfRaporGiris.Table.Btniptal')">
                                    <i class="bx bx-x label-icon"></i> </button>

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>


                          {{ AltDonemler.DonemAdi }}<br>




                        </th>
                      </template>

                    </tr>
                  </thead>
                  <tbody  v-for="(TabloDetay, index) in TabloDetayVerileri" :key="index">
                    <tr v-if="TabloDetay.Detay.Aktif">
                      <td>


                        {{ TabloDetay.Detay.Gostergesi }}

                        <a v-if="TabloDetay.Detay.Aciklama != null &&
                          TabloDetay.Detay.Aciklama != ''
                          " data-toggle="collapse" v-b-toggle="'satir' + index" role="button" aria-expanded="false"
                          aria-controls="categories-collapse">
                          <i style="font-size: 18px; margin-right:15px" class="mdi mdi-comment-question-outline "></i>
                        </a>
                        <br />

                        <b-collapse class="collapse show" :id="'satir' + index">
                          {{ TabloDetay.Detay.Aciklama }}
                        </b-collapse>
                        <!-- {{formul_goster(TabloDetay.Detay.FormulIcerik)}} -->
                      </td>
                      <td style="vertical-align: middle;text-align: center;">
                        {{ TabloDetay.Detay.HedefEtkisi }}
                      </td>

                      <template v-for="(AltDonemlerDetay, index) in TabloDetay.Giris">
                        <td :key="index"  v-if="AltDonemlerDetay.VeriTipi == 3 || Universite == 1 || AltDonemlerDetay.PerfGirisKurumBazinda == true || (AltDonemlerDetay.VeriTipi == 2 && AltDonemlerDetay.PerfGirisKurumBazinda == false)"
                          style="vertical-align: middle;text-align: center;">


                          <div>



                            <!-- Veri girişi inputu bölümü başlangıcı-->
                            <div v-if="(AltDonemlerDetay.Onay == 0 || AltDonemlerDetay.Onay == null) &&

                              (new Date(AltDonemlerDetay.BaslamaTarihi) < bugun &&
                                new Date(AltDonemlerDetay.BitisTarihi) > bugun) &&

                              (TabloDetay.Detay.SorguId == null || TabloDetay.Detay.SorguId == ''
                                || ((AltDonemlerDetay.VeriTipi == 2 && Universite == 1) || (AltDonemlerDetay.VeriTipi == 2 && AltDonemlerDetay.PerfGirisKurumBazinda == false)) || (AltDonemlerDetay.VeriTipi == 1 && Universite == 1)) &&

                              (TabloDetay.Detay.FormulIcerik == '' || TabloDetay.Detay.FormulIcerik == null
                                || ((AltDonemlerDetay.VeriTipi == 2 && Universite == 1) || (AltDonemlerDetay.VeriTipi == 2 && AltDonemlerDetay.PerfGirisKurumBazinda == false)) || (AltDonemlerDetay.VeriTipi == 1 && Universite == 1)) &&

                              (((AltDonemlerDetay.VeriTipi == 2 && Universite == 1) || (AltDonemlerDetay.VeriTipi == 2 && AltDonemlerDetay.PerfGirisKurumBazinda == false)) || (AltDonemlerDetay.VeriTipi == 1 && Universite == 1)
                                || TabloDetay.Detay.DetaydanHesaplamasin == true || TabloDetay.Detay.DetayVar == false
                                || TabloDetay.Detay.Verigirisiyapilmasin == false) && ((AltDonemlerDetay.OlcumPeriyodu == '00000000-0000-0000-0000-000000000000') || (AltDonemlerDetay.OlcumPeriyodu ==  AltDonemlerDetay.GostergeOlcumPeriyodu))


                              ">

                              <div v-if="(TabloDetay.Detay.HedefDonemlerindeKapali == false || AltDonemlerDetay.VeriTipi == 3
                                || (AltDonemlerDetay.VeriTipi == 1 && Universite == 1))">

                                <div v-if="TabloDetay.Detay.DetayVar == false || ((AltDonemlerDetay.VeriTipi == 2 && Universite == 1) || (AltDonemlerDetay.VeriTipi == 2 && AltDonemlerDetay.PerfGirisKurumBazinda == false))
                                  || TabloDetay.Detay.DetaydanHesaplamasin == true || (AltDonemlerDetay.VeriTipi == 1 && Universite == 1)">

                                  <input type="hidden" v-bind:value="AltDonemlerDetay.Kontrol = 1" id="gizli" />

                                  <input id="number" v-on:input="
                                    (AltDonemlerDetay.Deger = $event.target.value),
                                    (TabloDetay.DonemId = AltDonemlerDetay.DonemId)

                                    " v-bind:value="AltDonemlerDetay.Deger" @keyup.enter="
                                          enterla - exit - birlikte - calisiyor
                                          " @blur="kaydet(AltDonemlerDetay)" @focus="ilk_deger = AltDonemlerDetay.Deger"
                                    name="number" type="number" style="margin-bottom:5px;" class="form-control" />

                                </div>

                              </div>

                            </div>
                            <!-- Veri girişi inputu bölümü bitişi-->


                            <!--Veri girişinin kapalı olduğu sadece değer gözüken bölüm başlangıcı-->
                            <div v-if="AltDonemlerDetay.Kontrol == 0 || AltDonemlerDetay.Kontrol == null">

                              <div v-if="AltDonemlerDetay.Onay == 1 ||
                                TabloDetay.Detay.DetaydanHesaplamasin == false ||
                                TabloDetay.Detay.HedefDonemlerindeKapali == true ||
                                TabloDetay.Detay.Verigirisiyapilmasin == true ||
                                (TabloDetay.Detay.SorguId != null && TabloDetay.Detay.SorguId != '')

                                ">
                                <span v-if="AltDonemlerDetay.Onay == 1" style=" border-bottom: 2px solid green; ">
                                  {{ AltDonemlerDetay.Deger }}
                                </span>
                                <span v-if="AltDonemlerDetay.Onay == 0 && AltDonemlerDetay.VeriTipi != 2"
                                  style=" border-bottom: 2px solid red; ">
                                  {{ AltDonemlerDetay.Deger }}
                                </span>



                              </div>

                            </div>
                            <!--Veri girişinin kapalı olduğu sadece değer gözüken bitişi-->


                            <!--Açıklama Kanıt Detay buton kontrolleri başlangıcı-->

                            <div v-if="((AltDonemlerDetay.OlcumPeriyodu == '00000000-0000-0000-0000-000000000000') || (AltDonemlerDetay.OlcumPeriyodu ==  AltDonemlerDetay.GostergeOlcumPeriyodu))">

                              <span
                                v-if="AltDonemlerDetay.Onay == 1 && AltDonemlerDetay.Aciklama != null && AltDonemlerDetay.Aciklama != ''">
                                <b>
                                  <i style="font-size: 20px; margin-right:15px" class="mdi mdi-comment-plus-outline me-1"
                                    v-tooltip="$t('StrPerfRaporGiris.tooltip.AciklamaOku')
                                      " v-b-modal.AciklamaOku @click="$emit('TabloDetay', AltDonemlerDetay)"></i>

                                </b>
                              </span>

                              <span v-if="(AltDonemlerDetay.Onay == 0 ||
                                  AltDonemlerDetay.Onay == null) &&
                                new Date(AltDonemlerDetay.BaslamaTarihi) <
                                bugun &&
                                new Date(AltDonemlerDetay.BitisTarihi) > bugun
                                ">

                                <b>
                                  <i v-if="((AltDonemlerDetay.VeriTipi == 2 && AltDonemlerDetay.PerfGirisKurumBazinda == false)&& TabloDetay.Detay.HedefDonemlerindeKapali == false)
                                    || AltDonemlerDetay.VeriTipi == 3" style="font-size: 20px; margin-right:15px"
                                    class="mdi mdi-comment-plus-outline me-1" v-tooltip="$t('StrPerfRaporGiris.tooltip.Aciklama')
                                      " v-b-modal.Aciklama @click="$emit('TabloDetay', AltDonemlerDetay)"></i>

                                </b>

                                <b>

                                  <i v-if="TabloDetay.Detay.FormulIcerik != '' &&
                                    TabloDetay.Detay.FormulIcerik != null
                                    && AltDonemlerDetay.VeriTipi != 2
                                    " style="font-size: 20px; margin-right:15px"
                                    class="mdi mdi-calculator-variant-outline me-1" v-tooltip="$t('StrPerfRaporGiris.tooltip.Hesapla')
                                      " @click="
    hesapla(
      TabloDetay.Detay.FormulIcerik,
      AltDonemlerDetay,
      TabloDetay.Detay.Formulduzey
    )
    "></i>
                                </b>

                                <b>
                                  <i v-if="TabloDetay.Detay.SorguId != '' &&
                                    TabloDetay.Detay.SorguId != null
                                    && AltDonemlerDetay.VeriTipi != 2
                                    " style="font-size: 20px; margin-right:15px"
                                    class="mdi mdi-database-search-outline me-1" v-tooltip="$t('StrPerfRaporGiris.tooltip.Hesapla')
                                      " @click="
    sorgu_calistir(
      TabloDetay.Detay.SorguId,
      AltDonemlerDetay.DonemId,
      TabloDetay.Giris[0].BirimId,
      AltDonemlerDetay
    )
    "></i>

                                </b>


                              </span>
                              <span>
                                <b>
                                  <i style="font-size: 20px; margin-right:15px"
                                    class="mdi mdi-clipboard-edit-outline me-1" v-tooltip="$t('StrPerfRaporGiris.tooltip.KanitGerekli')
                                      " v-if="TabloDetay.Detay.KanitGerekli && AltDonemlerDetay.VeriTipi == 3"
                                    v-b-modal.StrKontrolGirisKanit
                                    @click="kanit_veri_gonder(AltDonemlerDetay.Id, AltDonemlerDetay.Onay)"></i>



                                </b>
                                <i style="font-size: 20px; margin-right:15px" class="mdi mdi-order-bool-descending me-1"
                                  v-tooltip="$t('StrPerfRaporGiris.tooltip.Detayvar')
                                    " v-if="TabloDetay.Detay.DetayVar && AltDonemlerDetay.VeriTipi == 3" v-b-modal.modal-lg2
                                  @click="
                                    veri_gonder(
                                      AltDonemlerDetay.DetayId,
                                      AltDonemlerDetay.DonemId,
                                      AltDonemlerDetay.BirimId,
                                      AltDonemlerDetay.Id,
                                      TabloDetay.Detay.Gostergesi,
                                      TabloDetay.Detay.DetaydanHesaplamasin,
                                      AltDonemlerDetay
                                    )
                                    "></i>
                              </span>
                            </div>
                            <!--Açıklama Kanıt Detay buton kontrolleri Bitişi-->


                            <div></div>
                          </div>
                        </td>

                      </template>

                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <br />
    </div>
  </div>
</template>
